import TagManager from "react-gtm-module";

export type GDPRConsent = {
  advertising: boolean;
  analytics: boolean;
  essential: boolean;
  functional: boolean;
};

export enum AnalyticsEvent {
  MODAL_ACCEPTED = "modal_accepted",
  MODAL_OPENED = "modal_opened",
  VIEW_ITEM = "view_item",
  BUTTON_STATE = "button_state",
  BUY_BUTTON_CLICKED = "buy_button_clicked",
  UNOWNED_PARENT_REDIRECT = "unowned_parent_redirect",
  PURCHASE = "purchase",
  PURCHASE_REQUEST = "purchase_request",
  PURCHASE_REQUEST_FAILED = "purchase_request_failed",
  EXPAND_DESCRIPTION = "expand_description",
  CHANGED_ABILITY = "changed_ability",
}

export const getGDPRConsent = (): GDPRConsent => {
  let storedGDPRPrefs;
  try {
    if (window.localStorage) {
      storedGDPRPrefs = JSON.parse(window.localStorage["truste.eu.cookie.notice_gdpr_prefs"]).value;
    }
  } catch (err) {
    // Invalid local storage value, fallback to cookies.
  }

  if (!storedGDPRPrefs) {
    const regex = new RegExp("notice_gdpr_prefs=([^;]*)");
    const match = regex.exec(document.cookie);

    if (match !== null) {
      storedGDPRPrefs = decodeURIComponent(match[1]);
    }
  }

  // User hasn't said anything yet
  if (!storedGDPRPrefs || storedGDPRPrefs.indexOf(":") === -1) {
    // All preferences are open
    return {
      advertising: true,
      analytics: true,
      essential: true,
      functional: true,
    };
  }

  // Read the part before the colon, split on the comma
  // and ensure we only get integers in the resulting array
  // Example value: 0,1,3:
  // Meaning: "accepted essential, functional and advertising" (missing 2 for "analytics")
  const knownConsent = storedGDPRPrefs
    .split(":")[0]
    .split(",")
    .map((i: string) => parseInt(i, 10));

  const consent: GDPRConsent = {
    advertising: knownConsent.indexOf("advertising") !== -1,
    analytics: knownConsent.indexOf("analytics") !== -1,
    essential: knownConsent.indexOf("essential") !== -1,
    functional: knownConsent.indexOf("functional") !== -1,
  };
  return consent;
};

export const sendAnalytics = (eventName: AnalyticsEvent, customData: object = {}): void => {
  // If we don't have consent or SSR, don't do anything
  if (typeof window === "undefined" || !getGDPRConsent().analytics) {
    return;
  }
  const event = eventName.toString().toLowerCase();
  const dataLayer = {
    ...customData,
    event,
  };
  TagManager.dataLayer({ dataLayer });
};
